import { HttpService } from '@maia/httpClient';
import { BaseService } from '@maia/feature-utils';
import { ConfigService } from '@maia/config';
import {
  ICompositionEntity,
  IDocumentCollection,
  IProductEntity,
  IQuotationEntity,
} from '../../shared';

export class QuotationService extends BaseService {
  constructor(httpService: HttpService, configService: ConfigService) {
    super(httpService, configService);
  }

  public async findMany(path: string, search: Record<string, unknown>) {
    return this.getMany<IQuotationEntity>(path, search, 'quotations');
  }

  public async find(path: string) {
    const res = await this.get<Array<IQuotationEntity>>(path, 'quotation');
    return Array.isArray(res) ? res[0] : res;
  }

  public async products(path: string) {
    return this.get<Array<IProductEntity>>(path, 'quotation products');
  }

  public async compositions(path: string) {
    return this.get<Array<ICompositionEntity>>(path, 'quotation compositions');
  }

  public async documents(path: string) {
    return this.get<Array<IDocumentCollection>>(path, 'quotation documents');
  }

  public async cancel(path: string) {
    return await this.put<unknown, unknown>(path, {}, 'quotation cancel');
  }

  public async remove(path: string) {
    return await this.delete<unknown>(path, 'quotation delete');
  }

  public async sendMail(path: string) {
    return await this.put<unknown, unknown>(path, {}, 'quotation mail');
  }
}
